<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Edición de módulos</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;"></div>
    <div class="container" style="display: flex; gap: 2%; margin-top: 20px; margin-left: 20px; position:relative;">
        <div class="col-6">
            <h5>Módulos</h5>
            <jqxGrid #grid [theme]="theme" [width]="'100%'" [height]="485" [source]="dataAdapter" [columnsresize]="true"
                [localization]="langGrid" [filterable]="true" [showfilterrow]="true" [columns]="columns"
                [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true"
                [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [enabletooltips]="true" [editable]="false" (onRowclick)="onRowSelect($event)">
            </jqxGrid>
            <div class="" style="display: flex; align-items: center; margin-top: 10px;">
                <jqxButton style="float: left; margin-right: 5px;" [width]='90' [height]='26' [theme]="theme"
                    [imgSrc]='"/assets/images/borrar.png"' (onClick)="onBorrarMenu()">
                    Borrar
                </jqxButton>
                <jqxButton style="float: left; margin-right: 0px;" [width]='100' [height]='26' [theme]="theme"
                    [imgSrc]='"/assets/images/mas.png"' (onClick)="onAddModulo()">
                    Nuevo
                </jqxButton>
            </div>
        </div>
        <div *ngIf="opcVisible" class="col-3"
            style="position: absolute; margin-left: 320px; z-index: 999; width: 330px;">
            <h5 style="float: left;">Opciones disponibles</h5>
            <jqxTree #menuOrigin [theme]="theme" [width]="300" [height]="446" [source]="recordsOri"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="false">
            </jqxTree>
        </div>

        <div class="col-3">
            <div style="float: left; display: flex; align-items: center;">
                <h5 style="float: left;">Opciones</h5>
                <jqxButton #btnMas style="float: left; margin-top: 0px; margin-left: 10px;" [width]='90' [height]='26'
                    [theme]="theme" [textImageRelation]="'textBeforeImage'" [imgPosition]="'right'"
                    [textPosition]="'left'" [imgSrc]="'/assets/images/opciones.png'" [value]="'Más...'"
                    (onClick)="onCrearOpcion()">
                </jqxButton>
                <div style="position: absolute; margin-left: 265px;">
                    <jqxTree #menuDel style="opacity: 0%; z-index: 999;" [theme]="theme" [width]="50" [height]="50"
                        [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="false" [allowDrop]="true">
                    </jqxTree>
                </div>
                <img src={{imageDelete}} class="movisatLogo"
                    style="float:left; z-index: 0; width: 36px; height: 36px; margin-left: 90px;" />

            </div>

            <jqxTree id="tree" #menuFinal [theme]="theme" [width]="300" [height]="446" [source]="recordsFin"
                [hasThreeStates]="false" [checkboxes]="false" [allowDrag]="true" [allowDrop]="true"
                (onDragStart)="onDragStart($event)" (onDragEnd)="onDragEnd($event)"
                (onSelect)="onSelectOpciones($event)">
            </jqxTree>

            <div>
                <jqxButton style="margin-top: 10px; float: left; margin-right: 0px;" [width]='100' [height]='26'
                    [theme]="theme" [imgSrc]='"/assets/images/save.png"' (onClick)="onGuardar()">
                    Guardar
                </jqxButton>
            </div>
        </div>
        <div class="col-2" style="border-style: ridge; border-width: 2px; width: 315px; height: 205px; ">
            <div style="margin-left: 5px; margin-top: 5px;">
                <h5>Nombre</h5>
                <jqxInput #ebNombre [width]="300" [height]="25" [(ngModel)]="newModulo.Nombre">
                </jqxInput>
                <h5 style="float: left; margin-top: 10px ;">
                    Observaciones
                </h5>
                <jqxInput #ebObserv [width]="300" [height]="25" [(ngModel)]="newModulo.Observaciones">
                </jqxInput>
                <div style="float: left; margin-top: 10px;">
                    <input #chbSoloMovisat type="checkbox" (change)="onChangeSoloMovisat($event) " />&nbsp;
                    Sólo Movisat
                </div>
                <div style="float: left; margin-top: 10px; background-color: beige; width: 300px; color: red;">
                    {{textoSeleccionado}}
                </div>
            </div>
        </div>
    </div>